<template lang="pug">
.ProductLines
  .ProductLines__Search
    select.ProductLines__Select(
      ref="select"
      v-model="selected"
      multiple
    )
      option(value="") What are you looking for?
      option(
        v-for="term in terms"
        :value="`cat-${term.term_id}`"
      ) {{ term.name }}
  .ProductLines__Items(ref="items")
    template(
      v-for="item in items"
    )
      .ProductLines__Item(
        :class="itemClass(item)"
      )
        product-line(
          :logo="item.logo"
          :title="item.title"
          :website="item.website"
          :terms="itemTerms(item)"
        )
</template>

<script>
import ProductLine from './ProductLine';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import Choices from 'choices.js';

export default {
  name: 'ProductLines',
  components: {ProductLine},
  props: {
    items: Array,
    terms: Array
  },
  data(){
    const termMap = {};
    this.terms.forEach( term => {
      termMap[term.term_id] = term;
    });
    const selected = [];
    return { termMap, selected }
  },
  mounted(){
    imagesLoaded( this.$el, () => {
      this.layout = new Isotope(this.$refs.items, {
        itemSelector: '.ProductLines__Item'
      });
      this.choices = new Choices( this.$refs.select, {
        searchPlaceholderValue: 'What are you looking for?',
        removeItemButton: true
      });
    });
  },
  watch: {
    selected(){
      this.choices.hideDropdown();
      this.choices.input.focus();
      this.layout.arrange({
        filter: this.selected.map(c=>`.${c}`).join(',')
      });
    }
  },
  methods: {
    itemTerms(item){
      return item.terms.map( id => this.termMap[id] );
    },
    itemClass(item){
      return item.terms.map( id => `cat-${id}` );
    }
  }
}
</script>
<style lang="scss">
.ProductLines { 
  $choices-border-radius-item: 10px;
  $choices-primary-color: #224365;
  @import '~choices.js/src/styles/choices.scss';
  .choices {
    &__input {
      background: transparent !important;
      border: none !important;
      padding: 7.5px 7.5px 3.75px;
    }
  }
}
</style>
<style lang="scss" scoped>
.ProductLines {
  &__Items {
    margin: 0 -20px 0;
  }
  &__Item {
    box-sizing: border;
    padding: 20px !important;

    @media( min-width: 700px ){
      width: 50%;
    }

    @media( min-width: 1000px ){
      width: 33.3333%;
    }
  }
  &__Search {
    margin-bottom: 20px;
  }
}
</style>